var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeDiamante(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 37L2.26918 16.4117C1.50919 15.4765 1.1292 15.0088 1.02711 14.4453C0.925013 13.8818 1.11737 13.3137 1.50208 12.1775L3.20305 7.15395C4.20872 4.18386 4.71155 2.69882 5.90866 1.84941C7.10577 1 8.69586 1 11.8761 1H26.1239C29.3041 1 30.8942 1 32.0913 1.84941C33.2884 2.69882 33.7913 4.18386 34.7969 7.15395L36.4979 12.1775C36.8826 13.3137 37.075 13.8818 36.9729 14.4453C36.8708 15.0088 36.4908 15.4765 35.7308 16.4117L19 37ZM19 37L26.9994 12.25M19 37L11.0006 12.25M36.1415 14.5L26.9994 12.25M26.9994 12.25L23.5711 3.25M26.9994 12.25H11.0006M11.0006 12.25L14.4289 3.25M11.0006 12.25L1.85846 14.5",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeDiamante);
export default __webpack_public_path__ + "static/media/icone_diamante.be2b7b94d72159d3f04558594ce21555.svg";
export { ForwardRef as ReactComponent };